import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Upload,
} from "antd";
import React from "react";
import { NewCompanyGstType_new } from "../../../Services/LedgerService";
import { useParams } from "react-router-dom";
import InventoryMasterService from "../../../Services/Inventory/InventoryMasterService";

interface IThiStepReg {
  index: number;
  form: any;
}
const ThirdStepReg = ({ index, form }: IThiStepReg) => {
  const { vendorClientId } = useParams();
  const [masterData, setMasterData] = React.useState<any>();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [gstType, setGSTType] = React.useState<any>();
  // const props: UploadProps = {
  //   name: "file",
  //   action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  //   headers: {
  //     authorization: "authorization-text",
  //   },
  //   showUploadList: false,
  //   onChange(info) {
  //     if (info.file.status !== "uploading") {
  //       console.log(info.file, info.fileList);
  //     }

  //   },
  // };

  React.useEffect(() => {
    getMasterDetails();
  }, []);

  const getMasterDetails = async () => {
    setLoading(true);
    let res = await InventoryMasterService?.getMasterDetails(
      vendorClientId,
      "",
      "",
      "",
      true
    );

    if (res?.result) {
      setMasterData(res?.result?.map((d: any) => ({ docType: d?.docType })));
      setLoading(false);
    } else {
      setMasterData([]);
      setLoading(false);
    }
  };

  return (
    <>
      <Spin indicator={<LoadingOutlined />} spinning={loading}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <Form.Item
            label="GST Type"
            name={[index, "GSTType"]}
            rules={[
              {
                required: true,
                message: "Please select the appropriate GST Type",
              },
            ]}
          >
            <Select
              placeholder="GST Type"
              options={[
                {
                  label: "Unregistered",
                  value: NewCompanyGstType_new.Unregistered,
                },
                {
                  label: "Regular",
                  value: NewCompanyGstType_new.Regular,
                },
                {
                  label: "Composition",
                  value: NewCompanyGstType_new.Composition,
                },
                {
                  label: "Unspecified",
                  value: NewCompanyGstType_new.Unspecified,
                },
                {
                  label: "Consumer",
                  value: NewCompanyGstType_new.Consumer,
                },
              ]}
              onChange={(val: any) => setGSTType(val)}
            />
          </Form.Item>

          {gstType !== 0 && (
            <>
              {masterData?.some((d: any) => d.docType === 1) && (
                <>
                  <Row gutter={10}>
                    <Col span={20}>
                      <Form.Item
                        name={[index, "GSTIN"]}
                        label="GSTIN"
                        rules={[
                          {
                            required: true,
                            // required:
                            //   gSTTypeValue === CompanyGSTTypes.Unregistered ||
                            //   gSTTypeValue === CompanyGSTTypes.Consumer
                            //     ? false
                            //     : true,
                            pattern:
                              /^(?!00)[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}Z[0-9A-Za-z]{1}$/,
                            message: "Enter Valid GST Number",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        name={[index, "GSTINDocument"]}
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          return e.fileList;
                        }}
                        // className="m-0"
                        style={{ paddingTop: "10px", margin: "0px" }}
                      >
                        <Upload
                          accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                          beforeUpload={(file: any) => {
                            if (file.size > 5242880) {
                              return Upload.LIST_IGNORE;
                            }

                            const reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = () => {
                              file.base64 = reader.result;
                              const formFieldValue =
                                form
                                  .useFormInstance()
                                  ?.getFieldValue([
                                    index,
                                    "equipmentListDocument",
                                  ]) || [];
                              form
                                .useFormInstance()
                                ?.setFieldsValue([
                                  index,
                                  "equipmentListDocument",
                                  [...formFieldValue, file],
                                ]);
                            };
                            return false; // Prevent auto-upload
                          }}
                        >
                          <Button
                            style={{ marginTop: "14px", color: "#058BC9" }}
                            icon={<UploadOutlined />}
                          >
                            Upload
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
            </>
          )}

          {masterData?.some((d: any) => d.docType === 2) && (
            <>
              <Row gutter={10}>
                <Col span={20}>
                  <Form.Item
                    label="PAN"
                    name={[index, "PAN"]}
                    rules={[
                      {
                        required: true,

                        pattern: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
                        message: "Enter Valid PAN Number",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    name={[index, "panDocument"]}
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      return e.fileList;
                    }}
                    // className="m-0"
                    style={{ paddingTop: "10px", margin: "0px" }}
                  >
                    <Upload
                      accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                      beforeUpload={(file: any) => {
                        if (file.size > 5242880) {
                          return Upload.LIST_IGNORE;
                        }

                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                          file.base64 = reader.result;
                          const formFieldValue =
                            form
                              .useFormInstance()
                              ?.getFieldValue([
                                index,
                                "equipmentListDocument",
                              ]) || [];
                          form
                            .useFormInstance()
                            ?.setFieldsValue([
                              index,
                              "equipmentListDocument",
                              [...formFieldValue, file],
                            ]);
                        };
                        return false; // Prevent auto-upload
                      }}
                    >
                      <Button
                        style={{ marginTop: "14px", color: "#058BC9" }}
                        icon={<UploadOutlined />}
                      >
                        Upload
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {masterData?.some((d: any) => d.docType === 5) && (
            <>
              <Row gutter={10}>
                <Col span={20}>
                  <Form.Item
                    label="Udhyam Aadhar"
                    name={[index, "udhyamAadhar"]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    name={[index, "udhyamAadharDocument"]}
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      return e.fileList;
                    }}
                    // className="m-0"
                    style={{ paddingTop: "10px", margin: "0px" }}
                  >
                    <Upload
                      accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                      beforeUpload={(file: any) => {
                        if (file.size > 5242880) {
                          return Upload.LIST_IGNORE;
                        }

                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                          file.base64 = reader.result;
                          const formFieldValue =
                            form
                              .useFormInstance()
                              ?.getFieldValue([
                                index,
                                "equipmentListDocument",
                              ]) || [];
                          form
                            .useFormInstance()
                            ?.setFieldsValue([
                              index,
                              "equipmentListDocument",
                              [...formFieldValue, file],
                            ]);
                        };
                        return false; // Prevent auto-upload
                      }}
                    >
                      <Button
                        style={{ marginTop: "14px", color: "#058BC9" }}
                        icon={<UploadOutlined />}
                      >
                        Upload
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </div>
      </Spin>
    </>
  );
};

export default ThirdStepReg;
